import * as yup from 'yup';
export const carePlanSchema = yup.object().camelCase().required().shape({
    id: yup.number().required().positive().integer(),
    patientId: yup.number().required().integer(),
    month: yup.string().required(),
    firstEdit: yup.date().nullable(),
    isEditable: yup.boolean().required(),
    createdAt: yup.date().required(),
    updatedAt: yup.date().required(),
    deletedAt: yup.date().nullable()
});
